/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { IReportDto } from '../Report.model'
import { useIntl } from 'react-intl'
import { IconLabelContent } from '../../../common/component/IconLabelContent'
import { Link } from 'react-router-dom'
import { parseLocalDate } from '../../../util/Locale'

interface Props {
  data: IReportDto
}

export const ReportInnerListItem: FC<Props> = ({
  data,
}: Props) => {
  const intl = useIntl()

  const buildAssetTypeDescriptionLine = (data: IReportDto) => {
    return `${data.asset.family} | ${data.asset.area} | ${data.asset.brand} | ${data.asset.model} | ${data.asset.serial}`
  }

  const buildAssetDetailsLine = (data: IReportDto) => {
    return `${data.address}`
  }

  return (
    <Link to={`/reports/${data.id}`} target='_blank'>
      <div className='bg-hover-light-primary py-2'>
        <div className='d-flex flex-stack'>
          <div className='d-flex align-items-center'>
            <div className='ms-2'>
              <div className='fs-7 cursor-pointer'>
                <span className='fw-bolder mb-2'>{`${parseLocalDate(
                  data.createdAt,
                  intl.formatMessage({id: 'I18N.LOCALE'})
                )} - ${data.client.displayName} `}</span>
                <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
                <span className='text-primary mb-2'>{data.sequence}</span>
              </div>

              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{buildAssetTypeDescriptionLine(data)}</span>
                </div>
              </div>

              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{buildAssetDetailsLine(data)}</span>
                </div>
              </div>

              <div className='d-flex justify-content-start align-items-center'>
                <IconLabelContent
                  title={
                    data.contract
                      ? `${intl.formatMessage({id: 'UTIL.CONTRACT'})} ${data.contract.sequence}`
                      : ''
                  }
                  active={!!data.contract}
                  icon='bi bi-vector-pen'
                />

                <IconLabelContent
                  title={
                    data.status === 'PENDING'
                      ? intl.formatMessage({id: 'TITLE.STATUS.PENDING'})
                      : intl.formatMessage({id: 'TITLE.STATUS.COMPLETE'})
                  }
                  active={data.status !== 'PENDING'}
                  icon='bi bi-check-circle'
                />

                <IconLabelContent
                  title={
                    data.shared
                      ? intl.formatMessage({id: 'TITLE.EMAIL.SHARED'})
                      : intl.formatMessage({id: 'TITLE.EMAIL.UNSHARED'})
                  }
                  active={data.shared}
                  icon='bi bi-envelope'
                />

                <IconLabelContent
                  title={
                    data.totalAttachment > 0
                      ? intl
                          .formatMessage({
                            id:
                              data.totalAttachment === 1
                                ? 'TITLE.ATTACHMENT.TOTAL_SINGLE'
                                : 'TITLE.ATTACHMENT.TOTAL_MULTIPLE',
                          })
                          .replace(/%s/g, `${data.totalAttachment}`)
                      : intl.formatMessage({id: 'TITLE.ATTACHMENT.ZERO'})
                  }
                  active={data.totalAttachment > 0}
                  labelValue={`${data.totalAttachment || ''}`}
                  icon='bi bi-paperclip'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
